import { PROFILE_ERROR, PROFILE_SUCCESS, EDIT_PROFILE, RESET_PROFILE_FLAG, CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_ERROR } from "./actionTypes";

const initialState = {
  error: "",
  success: "",
  changePasswordErrorMsg: null,
  changePasswordSuccess: null,
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PROFILE:
      state = { ...state };
      break;
    case PROFILE_SUCCESS:
      state = { ...state, success: action.payload };
      break;
    case PROFILE_ERROR:
      state = { ...state, error: action.payload };
      break;
    case RESET_PROFILE_FLAG:
      state = { ...state, success: null };
      break;
    case CHANGE_PASSWORD:
      state = {
        ...state,
        changePasswordSuccess: null,
        changePasswordErrorMsg: null
      }
      break
    case CHANGE_PASSWORD_SUCCESS:
      state = { ...state, changePasswordSuccess: true }
      break
    case CHANGE_PASSWORD_ERROR:
      state = { ...state, changePasswordErrorMsg: action.payload }
      break
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default profile;
